
import React from 'react';
import { Box, Text } from 'grommet';
import { isString } from 'lodash';

import FilterAttribute from '../common/FilterAttribute';

const renderSelectText = (text) => {
    return (
        <Box align="center" direction="row" pad="xsmall" width="250px">
            <Text>{text}</Text>
        </Box>
    );
}

const renderObdobi = (obdobi) => {
    return renderSelectText(`${obdobi.rok_od}-${obdobi.rok_do}`);
}

const renderObdobiOption = (option) => {
    return (isString(option))
        ? renderSelectText(option)
        : renderObdobi(option);
}

const renderObdobiValue = (value) => {
    return (value)
        ? renderObdobi(value)
        : null;
}

const renderOdruda = (odruda) => {
    return renderSelectText(`${odruda.odruda_nazev}`);
}

const renderOdrudaOption = (option) => {
    return (isString(option))
        ? renderSelectText(option)
        : renderOdruda(option);
}

const renderOdrudaValue = (value) => {
    return (value)
        ? renderOdruda(value)
        : null;
}

const FILTER_ATTRIBUTE_PODOBLAST = {
    id: 'podoblast',
    title: 'Podoblast',
    type: 'text'
};

const FILTER_ATTRIBUTE_OBEC = {
    id: 'obec',
    title: 'Obec',
    type: 'text'
};

const FILTER_ATTRIBUTE_KATASTR = {
    id: 'katastr',
    title: 'Katastr',
    type: 'text'
};

const FILTER_ATTRIBUTE_TRAT = {
    id: 'trat',
    title: 'Trať',
    type: 'text'
};

const FILTER_ATTRIBUTE_ODRUDA = {
    id: 'odruda',
    title: 'Výskyt odrůdy',
    type: 'select',
    values: [],
    renderValue: renderOdrudaValue,
    renderOption: renderOdrudaOption
};

const FILTER_ATTRIBUTE_OBDOBI = {
    id: 'obdobi',
    title: 'Období',
    type: 'select',
    values: [
        {rok_od: 1941, rok_do: 1950},
        {rok_od: 1951, rok_do: 1960},
        {rok_od: 1961, rok_do: 1970},
        {rok_od: 1971, rok_do: 1980},
        {rok_od: 1981, rok_do: 1990},
        {rok_od: 1991, rok_do: 2000},
        {rok_od: 2001, rok_do: 2010},
        {rok_od: 2011, rok_do: 2016}
    ],
    renderValue: renderObdobiValue,
    renderOption: renderObdobiOption
};

const getFilterAttributes = (tratOdrudaList) => {
    let filterAttributes = [];
    filterAttributes.push(FILTER_ATTRIBUTE_PODOBLAST);
    filterAttributes.push(FILTER_ATTRIBUTE_OBEC);
    filterAttributes.push(FILTER_ATTRIBUTE_KATASTR);
    filterAttributes.push(FILTER_ATTRIBUTE_TRAT);

    let filterAttributeOdruda = FILTER_ATTRIBUTE_ODRUDA;
    filterAttributeOdruda.values = tratOdrudaList;
    filterAttributes.push(filterAttributeOdruda);

    filterAttributes.push(FILTER_ATTRIBUTE_OBDOBI);
    return filterAttributes;
}

const getFilterAttributeValue = (attributes, filterAttribute) => {
    let value = attributes[filterAttribute.id];
    return filterAttribute.renderValue
        ? filterAttribute.renderValue(value)
        : value;
}

const TratFilter = ({attributes, tratOdrudaList, onChange}) => {
    return (
        <Box direction="row" wrap={true} pad={{bottom: '16px'}} >
            {getFilterAttributes(tratOdrudaList).map(item => {
                return (
                    <Box key={item.id} pad="xxsmall" style={{width: '456px'}}>
                        <FilterAttribute
                            filterItem={item}
                            onChange={onChange}
                            value={getFilterAttributeValue(attributes, item)}
                        />
                    </Box>
                );
            })}
        </Box>
    );
};

export default TratFilter;
